/* eslint-disable prettier/prettier */
import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { ReleaseChargeback } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const releaseChargeback = createAsyncThunk('chargeback/release', ReleaseChargeback);

export const ReleaseChargebackSlice = createSlice({
	name: 'releaseChargeback',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[releaseChargeback.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[releaseChargeback.rejected.toString()]: setAPIError,
		[releaseChargeback.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = payload;
		},
	},
});

interface IStates {
	[ReleaseChargebackSlice.name]: ReturnType<typeof ReleaseChargebackSlice.reducer>;
}

export const releaseChargebackSelector = (state: IStates): any => {
	return state[ReleaseChargebackSlice.name] || {};
};

export const useReleaseChargeback = (): any => useSelector(releaseChargebackSelector);

export const triggerReleaseChargeback =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(releaseChargeback(params));
		return;
	};

export const resetReleaseChargeback =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(ReleaseChargebackSlice.actions.RESET());
		return;
	};
